import { Wallet } from 'lucide-react';

import { TIPOS_BONUS } from '../bonus.api';
import { BonusSolicitudesPage } from './bonus-solicitudes-page';

/**
 * Bonus → Balance (`/bonus/balance`).
 *
 * Puerto de `Bonus::balance`: las consultas de saldo de puntos
 * (`loyalty/api/v2/Balance`). El panel anterior no mostraba el cuerpo enviado,
 * sólo la respuesta.
 */
export function BonusBalancePage() {
  return (
    <BonusSolicitudesPage
      eyebrow="Bonus"
      titulo="Balance"
      descripcion="Consultas de saldo de puntos realizadas al servicio de Bonus, con la respuesta de Primax."
      tipo={TIPOS_BONUS.balance}
      mostrarEnviados={false}
      icono={Wallet}
    />
  );
}
